import { SpotData } from "@swivl-mono/types";
import { type ReactNode } from "react";

import { BrandThemeProvider } from "../BrandTheme/BrandTheme";
import { SpotPageHeader } from "./Spot.Components";

interface Props {
  data: SpotData;
  children: ReactNode;
  position?: string;
  rounded?: boolean;
}

export function SpotMainLayoutComponent(props: Props) {
  const { data, children, rounded } = props;

  return (
    <BrandThemeProvider brand={data.brand}>
      <div
        id="mainLayout"
        className="swivl-themed flex-column fixed top-0 right-0 bottom-0 left-0 flex items-stretch justify-center"
        style={{ position: props.position ? (props.position as any) : "fixed" }}
      >
        <div
          className={`relative flex size-full flex-col overflow-y-auto bg-white md:max-w-screen-sm md:shadow-md ${rounded ? "md:mx-auto md:rounded-lg" : ""}`}
        >
          <SpotPageHeader {...data} />
          <div className="relative z-20 -mt-6 flex-1 rounded-t-2xl bg-white pt-6 pb-4">
            {children}
            <div className="right-0 bottom-20 left-0 z-50 justify-center p-3 text-center text-xs text-[#818181]">
              Powered by{" "}
              <a
                rel="noreferrer"
                className="text-[#818181] underline"
                href="https://www.tryswivl.com/?utm_source=spot-location&utm_medium=link-footer&utm_campaign=powered-by-swivl&utm_id=spot"
                target="_blank"
              >
                swivl
              </a>
            </div>
          </div>
        </div>
      </div>
    </BrandThemeProvider>
  );
}
